export enum SortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export enum BannersPlacementSlug {
  HOMEPAGE_BELOW_SEARCH = "HOMEPAGE_BELOW_SEARCH",
  HOMEPAGE_SLOT_1 = "HOMEPAGE_SLOT_1",
  HOMEPAGE_SLOT_2 = "HOMEPAGE_SLOT_2",
  HOMEPAGE_SLOT_3 = "HOMEPAGE_SLOT_3",
  HOMEPAGE_SLOT_4 = "HOMEPAGE_SLOT_4",
  HOMEPAGE_SLOT_5 = "HOMEPAGE_SLOT_5",
  FLIGHT_PAGE_SLOT_1 = "FLIGHT_PAGE_SLOT_1",
  FLIGHT_PAGE_SLOT_2 = "FLIGHT_PAGE_SLOT_2",
  FLIGHT_PAGE_SLOT_3 = "FLIGHT_PAGE_SLOT_3",
  HOTEL_PAGE_SLOT_1 = "HOTEL_PAGE_SLOT_1",
  HOTEL_PAGE_SLOT_2 = "HOTEL_PAGE_SLOT_2",
  HOTEL_PAGE_SLOT_3 = "HOTEL_PAGE_SLOT_3",
  CHECKOUT = "CHECKOUT",
  FLIGHTS_EMPTY_STATE = "FLIGHTS_EMPTY_STATE",
  HOTELS_EMPTY_STATE = "HOTELS_EMPTY_STATE",
  TRIPS_EMPTY_STATE = "TRIPS_EMPTY_STATE",
  TRAVELLERS_EMPTY_STATE = "TRAVELLERS_EMPTY_STATE",
}
